module.exports = __webpack_public_path__ + "static/media/table-sort-asc.17c80913.svg";